/*
ogElementReady is triggered when the element is rendered and ready in the DOM
*/

function ogElementReady($parse, $timeout) {
  return {
    restrict: 'A',
    link: ($scope, elem, attrs) => {
      angular.element($timeout(() => {
        const func = $parse(attrs.ogElementReady);
        func($scope);
      }));
    }
  };
}

ogElementReady.$inject = ['$parse', '$timeout'];

module.exports = ogElementReady;
